import script from "./LicenseplateCorrection.vue?vue&type=script&setup=true&lang=js"
export * from "./LicenseplateCorrection.vue?vue&type=script&setup=true&lang=js"

import "./LicenseplateCorrection.vue?vue&type=style&index=0&id=51e0cc8d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shareTeam\\Desktop\\work\\parking\\duty-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51e0cc8d"]])

export default __exports__